import React, { useEffect, useCallback, useState, useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
  TextField,
  ListContextProvider,
  useListContext,
  ReferenceField,
} from 'react-admin';

import { Card, makeStyles, Divider, Tabs, Tab } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_FARDAMENTOS_LISTAR } from '../../utils/dadosTelas';
import Dialogo from './DialogoCreateEdit';
import Filter from './Filter';

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: theme.palette.primary.main,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refDialogoConfirmacao = useRef(null);
  const refresh = useRefresh();
  const classes = useStyles();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }

  function handleClose() {
    refresh();
  }

  //////////////////////

  async function ativar(id) {
    await api.put(`/fardamentos/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/fardamentos/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/fardamentos/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  /////////////////////

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Fardamento',
        'Deseja realmente reativar este Fardamento?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Fardamento',
        'Deseja realmente desativar este Fardamento?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Fardamento',
        'Deseja deletar permanentemente este Fardamento?',
        { id, codigo: 3 },
      );
    }
  }

  /////////////////////

  return (
    <>
      <Title title="Fardamentos" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props}>
                <TextField
                  source="nome"
                  label="Descrição"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ReferenceField
                  label="Tamanho"
                  source="tamanho_fardamento_id"
                  reference="tamanhos_fardamentos"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*             handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                    },
                    {
                      key: 'deletar',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <TextField
                  source="nome"
                  label="Descrição"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <ReferenceField
                  label="Tamanho"
                  source="tamanho_fardamento_id"
                  reference="tamanhos_fardamentos"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*                 handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => handleEdit(rec),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                    },
                    {
                      key: 'deletar',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_FARDAMENTOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Fardamentos"
    />
  </ProtegerPagina>
);

export default List2;
